import {Component, OnInit} from '@angular/core';
import {
  ConfiguratorAttributeCheckBoxListComponent,
  ConfiguratorAttributeCompositionContext,
  ConfiguratorAttributeQuantityService,
  ConfiguratorCommonsService,
  ConfiguratorStorefrontUtilsService,
} from '@spartacus/product-configurator/rulebased';
import {ADDITIONAL_SERVICES_GROUP_NAME} from '../../utils';
import {StepInputService, UdexEventTypeService} from '../../services';

@Component({
  selector: 'dcp-configurator-attribute-checkbox-list',
  templateUrl: './dcp-configurator-attribute-checkbox-list.component.html',
  styleUrls: [
    './../dcp-configurator-attribute-checkbox/dcp-configurator-attribute-checkbox.component.scss',
    './dcp-configurator-attribute-checkbox-list.component.scss',
  ],
})
export class DcpConfiguratorAttributeCheckboxListComponent
  extends ConfiguratorAttributeCheckBoxListComponent
  implements OnInit
{
  withLongTextUsedForDisplay?: boolean;

  constructor(
    protected override configUtilsService: ConfiguratorStorefrontUtilsService,
    protected override quantityService: ConfiguratorAttributeQuantityService,
    configuratorAttributeCompositionContext: ConfiguratorAttributeCompositionContext,
    configuratorCommonsService: ConfiguratorCommonsService,
    protected stepInputService: StepInputService,
    protected udexEventTypeService: UdexEventTypeService,
  ) {
    super(configUtilsService, quantityService, configuratorAttributeCompositionContext, configuratorCommonsService);
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.withLongTextUsedForDisplay = this.group.endsWith(ADDITIONAL_SERVICES_GROUP_NAME);
  }

  onAttributeChange(index: number): void {
    this.attributeCheckBoxForms[index].patchValue(!this.attributeCheckBoxForms[index].value);
    if (this.attribute.values) {
      this.attribute.values[index].selected = this.attributeCheckBoxForms[index].value ?? false;
    }
    this.onSelect();
  }
}
